import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// views
import Login from "views/auth/Login.js";
import Register from "views/auth/Register.js";
import AdminRegister from "views/auth/AdminRegister";
import Logout from "views/auth/Logout";
import OTPVerification from "views/auth/OtpVerificationPage";
import ForgotPassword from "views/auth/ForgotPassword";

export default function Auth() {
  return (
    <main className="overflow-hidden h-screen">
      <section className="relative w-full h-full min-h-screen overflow-hidden">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/verify/otp" element={<OTPVerification />} />
          <Route path="/register" element={<Register />} />
          <Route path="/admin/register" element={<AdminRegister />} />
          <Route path="/logout" element={<Logout />} />

          <Route path="/" element={<Navigate to="/auth/login" replace />} />
          <Route path="*" element={<Navigate to="/auth/login" replace />} />
        </Routes>
      </section>
    </main>
  );
}